module.exports = __webpack_public_path__ + "static/media/rar.a2cba165.svg";